import {
  Measure
} from '../../common/measure';

require('./summ-stat.component.scss');

/*@ngInject*/
class SummStatController {
  constructor(
    $scope,
    $element,
    $timeout,
    CurrentModelService,
    CurrentFilterService,
    RouterService,
    LayoutService,
    rx,
  ) {
    this.$scope = $scope;
    this.$element = $element;
    this.$timeout = $timeout;
    this.LayoutService = LayoutService;
    this.LayoutService.drilldownMax = 1;
    this.getMeasure = Measure.getMeasure;
    this.getMeasureLabel = Measure.getMeasureLabel;
    this.CurrentModelService = CurrentModelService;
    this.filterBar = CurrentFilterService.filterBar;
    this.router = RouterService;
    this.totalStyle = {
      'font-size': '18px',
      'line-height': '18px'
    };
    this.LayoutService = LayoutService;
    this.$timeout(() => this.resize(), 100);
    this.resize();
    const subscription = rx.Observable.merge(
        $scope.$eventToObservable('resizeBeforePrint'),
        // $scope.$eventToObservable('init'),
        rx.Observable.merge(
          $scope.$eventToObservable('beforePrint'),
          $scope.$eventToObservable('dashboardResize'),
          $scope.$eventToObservable('resize'),
          $scope.$eventToObservable('splitter1Changed'),
        ).debounce(100))
      .subscribe((e) => this.resize(e));

    $scope.$on('$destroy', () => {
      subscription.dispose();
      this.LayoutService.drilldownMax = 0;
    });
  }

  resize() {
    const size = this.$element[0].getClientRects()[0];
    const fontSize = size ? `${Math.min((size.width - 30) / 20, size.height - 30)}px` : '18px';
    this.totalStyle['font-size'] = fontSize;
    this.totalStyle['line-height'] = fontSize;
    this.$timeout(() => {
      this.$scope.$apply();
    }, 10);
  }

  get measureLabel() {
    if (!this.filterData || !this.filterData.filterData.cells.length) return '';
    if (this.filter.measure === 'total_elements') return gettext('Всего');
    return this.getMeasureLabel(this.filter.measure);
  }

  get total() {
    if (!this.filterData || !this.filterData.filterData.cells.length) return '-';
    if (this.filter.measure === 'total_elements') return `${this.filterData.filterData.cells.length}`;
    const summ = this.filterData.filterData.cells.reduce((sum, cell) => sum + cell[this.filter.measure], 0);
    // const label = this.getMeasureLabel(this.filter.measure);
    return `${this.getMeasure(summ, this.filter.measure)}`;
  }
}

export const SummStatComponent = {
  template: require('./summ-stat.component.html'),
  bindings: {
    model: '<',
    filterData: '<',
    filter: '<',
  },
  controller: SummStatController,
};



// WEBPACK FOOTER //
// ./src/stat/summ-stat/summ-stat.component.js